import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableReCaptchaGiftCard',
  initialState: false,
  reducers: {
    setEnableReCaptchaGiftCard(_state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableReCaptchaGiftCard } = slice.actions;

export default slice.reducer;
